import RequestHandler from './RequestHandler';
export default class UserAgentHelper extends RequestHandler {
    static getUserAgent() {
        var _a;
        if (typeof window === 'undefined') {
            return this.getServerAgent() || '';
        }
        const clientUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
        if (clientUA)
            return clientUA;
        return this.getServerAgent() || '';
    }
    static getUADataModel() {
        var _a;
        return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.model) || '';
    }
}
